export default class Facade {
    constructor(el){

        this.videos = el;
        this.videos.addEventListener('click', () => {
            this.facadeInit(this.videos);
        });
    }

    facadeInit(data){
        let frame;
        let service = data.getAttribute('data-service');
        if(data.classList.contains('video--facade--youtube')) {
            let id = data.getAttribute('data-id');
            frame = '<div class="youtube_player video--player" videoID="' + id + '" theme="dark" controls="1" autoplay="1" mute="1" width="100%" height="auto"></div>';
        } else if (data.classList.contains('video--facade--vimeo')) {
            let id = data.getAttribute('data-id');
            frame = '<div class="vimeo_player video--player" videoID="' + id +'" autoplay="1"></div>';
        }
        while (data.firstChild){
            data.removeChild(data.firstChild)
        }
        data.classList.remove('video--facade');
        data.innerHTML = frame;
        (tarteaucitron.job = tarteaucitron.job || []).push(service);
    }
}